import { Button, ButtonProps } from '@mui/material';
import { SxProps } from '@mui/material/styles';
import React, { FC } from 'react';
import brandclub_colors from '../../colors/brandclubColors';

interface AppButtonCustomProps {
  invertStyle?: boolean;
  textColor?: string;
  backgroundColor?: string;
  sx?: SxProps;
}

export type AppButtonProps = AppButtonCustomProps & ButtonProps;

export const AppButton: FC<AppButtonProps> = ({ invertStyle, children, textColor, backgroundColor, sx, ...rest }) => {
  return (
    <Button
      disableRipple
      {...rest}
      sx={[
        {
          height: 28,
          backgroundColor: backgroundColor || (invertStyle ? brandclub_colors.darkBlue : brandclub_colors.white),
          border: backgroundColor
            ? 'none'
            : `1px solid ${invertStyle ? brandclub_colors.darkBlue : brandclub_colors.grayLight}`,
          borderRadius: 5,
          color: textColor || (invertStyle ? brandclub_colors.white : brandclub_colors.darkBlue),
          fontSize: '1.1rem',
          fontWeight: 500,
          fontFamily: 'Roboto',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: backgroundColor || (invertStyle ? brandclub_colors.darkBlue : brandclub_colors.blueWhite),
            transition: 'background-color 0.25s ease',
          },
          '&.Mui-disabled': {
            opacity: invertStyle ? 0.6 : 1,
            color: invertStyle ? brandclub_colors.white : brandclub_colors.gray5,
            transition: 'background-color 0.25s ease',
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Button>
  );
};
